import { Link } from 'react-router-dom';

const nav = [['Home', '/'], ['Services', '/services'], ['About', '/about'], ['Contact', '/contact']];

export default function Footer() {
  return (
    <footer className="bg-white px-0 md:px-4 lg:px-6 pb-0 md:pb-4 lg:pb-6">
      <div className="cut-tl bg-background-100" style={{ ['--cut' as string]: '56px' }}>
        <div className="wrap pt-14 md:pt-20 pb-8">
          <div className="mx-auto max-w-[1280px]">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-10 pb-12 md:pb-16 border-b border-foreground-950/15">
              <div className="sm:col-span-2 lg:col-span-6">
                <Link to="/" className="font-label text-[15px] font-semibold tracking-[0.22em] text-foreground-950 cursor-pointer">
                  MORROW PEOPLE
                </Link>
                <p className="mt-5 max-w-[400px] text-[15px] leading-[1.65] text-foreground-700">
                  An independent HR &amp; talent advisory helping ambitious organisations find exceptional people and build teams ready for what comes next.
                </p>
              </div>
              <div className="lg:col-span-3">
                <h4 className="font-label text-[12px] uppercase tracking-[0.18em] text-foreground-500 mb-5">
                  <a href="#footer-nav">Navigate</a>
                </h4>
                <ul id="footer-nav" className="flex flex-row flex-wrap gap-x-6 gap-y-3 lg:flex-col lg:gap-3 text-[15px]">
                  {nav.map(([l, t]) => (
                    <li key={t}>
                      <Link to={t} className="whitespace-nowrap text-foreground-800 hover:text-accent-600 transition-colors cursor-pointer">{l}</Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="lg:col-span-3">
                <h4 className="font-label text-[12px] uppercase tracking-[0.18em] text-foreground-500 mb-5">
                  <a href="#footer-contact">Contact</a>
                </h4>
                <ul id="footer-contact" className="flex flex-col gap-3 text-[15px]">
                  <li>
                    <Link to="/contact" className="inline-flex items-center gap-1 text-foreground-950 border-b border-foreground-950/40 pb-0.5 hover:text-accent-600 hover:border-accent-500 transition-colors whitespace-nowrap cursor-pointer">
                      Start a conversation <i className="ri-arrow-right-up-line"></i>
                    </Link>
                  </li>
                  <li className="text-foreground-600">Independent HR &amp; Talent Advisory</li>
                </ul>
              </div>
            </div>
            <div className="pt-6 flex flex-col sm:flex-row justify-between gap-3 text-[13px] text-foreground-600">
              <p>&copy; 2026 Morrow People. All rights reserved.</p>
              <p>Built around people.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}